import { connect } from 'react-redux';
import BindList from '../components/ThetaBindList';

import * as actions from '../actions/ThetaBindList'

const mapStateToProps = (state, ownProps) => ({
   categoryId: ownProps.categoryId,
   category: state.BindList.category,
   ranking: state.BindList.ranking,
   checkedB: state.BindList.checkedB,
   getOptions: state.BindList.getOptions,
   videoJsOptions: state.BindList.videoJsOptions,
   item: state.BindList.item,
   uploadCheck:state.BindList.uploadCheck,
   value: state.BindList.value,
   statusCode:state.BindList.statusCode,
   error: state.BindList.error
});

const mapDispatchToProps = dispatch => ({
    onMount(categoryId) {
        dispatch(actions.fetchRanking(categoryId));
    },
    onUpdate(categoryId) {
        dispatch(actions.fetchRanking(categoryId));
    },
    onPostDate(ranking, item,deleteFlg,checkedB) {
        dispatch(actions.postData(ranking, item,deleteFlg,checkedB));
    },
    onShootingMount(devicename) {
       dispatch(actions.getOptions(devicename));
    },
    onShootingPostDate(devicename, commands) {
        dispatch(actions.postShootingData(devicename, commands));
    },
    onUnsubscribeAccount(statusCode){
        dispatch(actions.unsubscribeAccount(statusCode));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(BindList);



// WEBPACK FOOTER //
// ./src/containers/ThetaBindList.js